<template>
    <div class="account">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Enrollment Account
                    </div>

                    <br />

                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                        <button type="button" class="btn btn-success" @click="openModal" :disabled="loading"
                            v-if="!model.created_at || model.deleted_at">
                            Update Enrollment
                        </button>
                    </div>
                </div>
            </legend>

            <div class="row" v-if="!loading && project.isMultiSignature && (!model.created_at || model.deleted_at)">
                <p style="text-transform: none; font-size: 1.2rem; margin-left: 20px;">
                    <i>Note:</i> The resident must enroll themselves via the Resident Portal since this is a
                    multi-signature enrollment project.
                </p>
            </div>

            <div class="list-group">
                <a href="javascript://void(0)" v-if="autoEnrollBlock.created_at && !autoEnrollBlock.deleted_at"
                    class="list-group-item cursor" @click="openModal">
                    <div class="row">
                        <div class="col-xs-6">
                            <dl class="no-margin">
                                <dt>Auto Enroll {{ autoEnrollEnabled ? 'Enabled' : 'Disabled' }}</dt>
                                <dd>
                                    {{ autoEnrollBlock.created_at | date }}
                                </dd>
                            </dl>
                        </div>
                        <div class="col-xs-6">
                            <dl class="no-margin" v-if="autoEnrollBlock.expires_at">
                                <dt>Auto Enroll Enabled After</dt>
                                <dd>
                                    {{ autoEnrollBlock.expires_at | date }}
                                </dd>
                            </dl>
                        </div>
                    </div>
                </a>

                <a href="javascript://void(0)" v-if="enrollmentBlock.created_at && !enrollmentBlock.deleted_at"
                    class="list-group-item cursor" @click="openModal">
                    <div class="form-group">
                        <dl class="no-margin">
                            <dt>Opted Out</dt>
                            <dd>
                                {{ enrollmentBlock.created_at | date }}
                            </dd>
                        </dl>
                    </div>
                </a>

                <a href="javascript://void(0)" v-else-if="model.created_at && !model.deleted_at"
                    class="list-group-item cursor" @click="openModal">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-xs-12 col-sm-3">
                                <dl class="no-margin">
                                    <dt>Charge</dt>
                                    <dd>
                                        <h2 class="currency" v-html="$options.filters.displayCurrency(model.charge)">
                                        </h2>
                                    </dd>
                                </dl>
                            </div>
                            <div class="col-xs-6 col-sm-4">
                                <dl class="no-margin">
                                    <dt v-if="!partialEnrollment">Enrolled On</dt>
                                    <dt v-else-if="partialEnrollment">Partially Enrolled On</dt>
                                    <dd>{{ model.created_at | date }}</dd>
                                </dl>
                            </div>
                            <div class="col-xs-6 col-sm-5">
                                <dl class="no-margin" v-if="model.creatingUser">
                                    <dt v-if="!partialEnrollment">Enrolled By</dt>
                                    <dt v-else-if="partialEnrollment">Partially Enrolled By</dt>

                                    <dd>
                                        <a :href="'/users/' + model.creatingUser.id">
                                            {{ model.creatingUser.fullName }}
                                        </a>
                                    </dd>
                                </dl>
                            </div>
                        </div>

                        <dl class="no-margin">
                            <dt>Products</dt>
                            <dd>
                                <ul class="list-unstyled">
                                    <li v-for="accountProduct in model.accountProducts" :key="accountProduct.id">
                                        <h5 class="text-normal">
                                            {{ accountProduct.product.title }}
                                            <span v-html="accountProduct.product.typeLabel"></span>
                                        </h5>

                                        <h6 class="text-med-grey text-normal margin-sm-bottom">
                                            {{ accountProduct.product.description }}
                                        </h6>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </div>
                </a>
            </div>
        </fieldset>

        <modal :name=modalId :adaptive="true" :scrollable="true" height="auto" style="padding: 3rem 0 6rem 0;">
            <div class="dashboard-block" :class="{ loading: loading }">
                <header>
                    <h4 v-if="model.created_at" class="display-block">
                        Account
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h4 v-else>Enroll</h4>

                    <h5 v-if="model.created_at && model.project && model.project.property">
                        <a :href="'/properties/' + model.project.property_id">
                            {{ model.project.property.name }}
                        </a>
                    </h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <div class="form-group" v-if="model.created_at">
                    <div class="row">
                        <div class="col-xs-12 col-sm-3">
                            <dl class="no-margin">
                                <dt>Charge</dt>
                                <dd>
                                    <h2 class="currency" v-html="$options.filters.displayCurrency(model.charge)"></h2>
                                </dd>
                            </dl>
                        </div>
                        <div class="col-xs-6 col-sm-4">
                            <dl class="no-margin">
                                <dt v-if="!partialEnrollment">Enrolled On</dt>
                                <dt v-else-if="partialEnrollment">Partially Enrolled On</dt>
                                <dd>{{ model.created_at | date }}</dd>
                            </dl>
                        </div>
                        <div class="col-xs-6 col-sm-5">
                            <dl class="no-margin" v-if="model.creatingUser">
                                <dt v-if="!partialEnrollment">Enrolled By</dt>
                                <dt v-else-if="partialEnrollment">Partially Enrolled By</dt>

                                <dd>
                                    <a :href="'/users/' + model.creatingUser.id">
                                        {{ model.creatingUser.fullName }}
                                    </a>
                                </dd>
                            </dl>
                        </div>
                    </div>

                    <dl class="no-margin">
                        <dt>Products</dt>
                        <dd>
                            <ul class="list-unstyled">
                                <li v-for="accountProduct in model.accountProducts" :key="accountProduct.id">
                                    <h5 class="text-normal">
                                        {{ accountProduct.product.title }}
                                        <span v-html="accountProduct.product.typeLabel"></span>
                                    </h5>

                                    <h6 class="text-med-grey text-normal margin-sm-bottom">
                                        {{ accountProduct.product.description }}
                                    </h6>
                                </li>
                            </ul>
                        </dd>
                    </dl>
                </div>

                <div v-else-if="autoEnrollBlock.created_at && !autoEnrollBlock.deleted_at">
                    <div class="form-group">
                        <dl class="no-margin">
                            <dt>Auto Enroll Disabled</dt>
                            <dd>
                                {{ autoEnrollBlock.created_at | date }}
                            </dd>
                        </dl>
                    </div>
                </div>

                <tabs>
                    <tab :title="model.created_at ? 'Edit' : 'Enroll'"
                        v-if="!enrollmentBlock.created_at || enrollmentBlock.deleted_at">
                        <fieldset>
                            <legend>Enrollment Account</legend>

                            <project-phone-agreement v-if="accountable.id" class="text-right"
                                :account-id="model.id ? model.id : null" :accountable="accountable"
                                :en-agreement-id="project.agreement_id" :es-agreement-id="project.es_agreement_id"
                                :model-id="'set-to-allow-load'" :project-id="project.id">
                                <a href="javascript://void">
                                    Show Phone Script
                                </a>
                            </project-phone-agreement>

                            <div v-if="chargeBlock.created_at">
                                <h5>Price Locked Until <b>{{ chargeBlock.expires_at | date }}</b></h5>

                                <dl class="no-margin" v-if="chargeBlock.creatingUser">
                                    <dt>Locked By</dt>

                                    <dd>
                                        <a :href="'/users/' + chargeBlock.creatingUser.id">
                                            {{ chargeBlock.creatingUser.fullName }}
                                        </a>
                                    </dd>
                                </dl>

                                <hr>

                                <div class="row">
                                    <div class="col-xs-6">
                                        <button type="button" class="btn btn-sm btn-warning"
                                            @click="deleteBlock(chargeBlock.id)"
                                            v-if="chargeBlock.created_at && !chargeBlock.deleted_at"
                                            :disabled="loading">
                                            Remove Lock
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <form v-if="!chargeBlock.created_at" @submit.prevent="saveModel" accept-charset="UTF-8"
                                novalidate="novalidate" data-vv-scope="account">

                                <div class="row">
                                    <div class="form-group has-feedback col-sm-8 col-md-6" v-if="!model.deleted_at"
                                        :class="{ 'has-error': errors.has('account.Account[charge]') }">
                                        <label for="account-charge">Charge</label>
                                        <span style="color: gray; font-style: italic; font-size: .9rem;"
                                            v-if="project.renewalPrice && project.price && model.charge === project.renewalPrice.amount && project.renewalPrice.amount < project.price.amount && leaseIsRenewal">
                                            - Lease Renewal Price&nbsp;
                                            <i class="fa fa-info-circle text-gray tool-tip">
                                                <span class="tool-tip-text" style="z-index: 3; font-size: 1rem;">
                                                    The lease associated with this account is a renewal, so the price
                                                    may be lower than the project price shown.
                                                </span>
                                            </i>
                                        </span>

                                        <div class="input-group">
                                            <span class="input-group-addon">$</span>

                                            <input id="account-charge" aria-required="true" autocomplete="off"
                                                class="form-control" min="0" name="Account[charge]" required="required"
                                                type="number" v-validate="'required'" v-model.number="model.charge">
                                        </div>

                                        <span v-show="errors.has('account.Account[charge]')" class="help-block">
                                            {{ errors.first('account.Account[charge]') }}
                                        </span>
                                    </div>

                                    <div class="form-group has-feedback col-sm-8 col-md-6"
                                        v-if="!chargeBlock.created_at"
                                        :class="{ 'has-error': errors.has('account.Block[expires_at]') }">
                                        <label for="account-block-expires-at">Price Locked Until</label>

                                        <input id="account-block-expires-at" autocomplete="off" class="form-control"
                                            name="Block[expires_at]" type="date" v-model="chargeBlock.expires_at">

                                        <span v-show="errors.has('account.Block[expires_at]')" class="help-block">
                                            {{ errors.first('account.Block[expires_at]') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group has-feedback col-sm-8 col-md-6">
                                        <label for="account-block-expires-at">Is SMS Enrollment</label>
                                        <input type="checkbox" id="smsCheckbox" v-model="smsCheckboxVal">

                                    </div>
                                    <div v-show="smsCheckboxVal">
                                        <div class="form-group has-feedback col-sm-8 col-md-6">
                                            <label for="account-block-expires-at">SMS Phone Number</label>
                                            <input v-model="smsNumber" placeholder="SMS Phone Number">
                                        </div>
                                    </div>
                                </div>

                                <hr v-if="!model.deleted_at">

                                <div class="row">
                                    <div class="col-xs-6">
                                        <button type="button" class="btn btn-sm btn-warning"
                                            @click="() => project.isMultiSignature ? null : deleteModel()"
                                            v-if="model.created_at && !model.deleted_at"
                                            :disabled="project.isMultiSignature || loading">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-warning"
                                            @click="() => project.isMultiSignature ? null : restoreModel()"
                                            v-if="model.created_at && model.deleted_at"
                                            :disabled="project.isMultiSignature || loading">
                                            <i class="fa fa-refresh" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <div class="col-xs-6 form-group pull-right" v-if="!model.deleted_at">
                                        <button type="submit" class="btn btn-success btn-block"
                                            :disabled="loading || (project.isMultiSignature && !model.created_at)">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </fieldset>
                    </tab>

                    <tab title="Agreements"
                        v-if="model.created_at && (!enrollmentBlock.created_at || enrollmentBlock.deleted_at)">
                        <account-agreements :accountable-id="accountableId" :accountable-type="accountableType"
                            :accountable="accountable" :project="project" :accountId="model.id">
                        </account-agreements>
                    </tab>

                    <tab title="Members"
                        v-if="model.created_at && (!enrollmentBlock.created_at || enrollmentBlock.deleted_at)">
                        <account-members @afterSave="init" :is-multi-signature="project.isMultiSignature"
                            :account="model" :accountId="model.id" :accountable-id="accountableId"
                            :accountable-type="accountableType" :project-id="projectId">
                        </account-members>
                    </tab>

                    <tab title="Auto Enroll"
                        v-if="!model.created_at && (!enrollmentBlock.created_at || enrollmentBlock.deleted_at)">
                        <form @submit.prevent="saveAutoEnrollBlock" accept-charset="UTF-8" novalidate="novalidate"
                            data-vv-scope="autoEnrollBlock">
                            <fieldset>
                                <legend>Auto Enroll</legend>

                                <div v-if="autoEnrollBlock.created_at && !autoEnrollBlock.deleted_at">
                                    <div class="row">
                                        <div class="col-xs-6">
                                            <dl class="no-margin">
                                                <dt>Auto Enroll Disabled</dt>
                                                <dd>
                                                    {{ autoEnrollBlock.created_at | date }}
                                                </dd>
                                            </dl>
                                        </div>
                                        <div class="col-xs-6">
                                            <dl class="no-margin" v-if="autoEnrollBlock.expires_at">
                                                <dt>Auto Enroll Enabled After</dt>
                                                <dd>
                                                    {{ autoEnrollBlock.expires_at | date }}
                                                </dd>
                                            </dl>
                                        </div>
                                    </div>

                                    <hr>

                                    <div>
                                        <button type="button" class="btn btn-sm btn-warning"
                                            @click="deleteBlock(autoEnrollBlock.id)" :disabled="loading">
                                            Enable Auto Enroll
                                        </button>
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="row">
                                        <div class="form-group has-feedback col-sm-6"
                                            :class="{ 'has-error': errors.has('autoEnrollBlock.Block[expires_at]') }">
                                            <label for="block-expires-at">Expiration</label>

                                            <input id="block-expires-at" type="date" placeholder="YYYY-MM-DD"
                                                class="form-control" name="Block[expires_at]" :min="tomorrow"
                                                v-model="autoEnrollBlock.expires_at">

                                            <span v-show="errors.has('autoEnrollBlock.Block[expires_at]')"
                                                class="help-block">
                                                {{ errors.first('autoEnrollBlock.Block[expires_at]') }}
                                            </span>
                                        </div>
                                    </div>

                                    <hr>

                                    <div class="row">
                                        <div class="col-xs-6">
                                        </div>

                                        <div class="col-xs-6 form-group pull-right">
                                            <button type="submit" class="btn btn-primary btn-block" :disabled="loading">
                                                Disable Auto Enroll
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </tab>

                    <tab title="Opt Out">
                        <fieldset>
                            <div v-if="enrollmentBlock.created_at && !enrollmentBlock.deleted_at">
                                <dl>
                                    <dt>Opted Out</dt>
                                    <dd>
                                        {{ enrollmentBlock.created_at | date }}
                                    </dd>

                                    <dt>Blocked Until</dt>
                                    <dd v-if="enrollmentBlock.expires_at">
                                        {{ enrollmentBlock.expires_at | date }}
                                    </dd>
                                    <dd v-else>
                                        No Expiration
                                    </dd>
                                </dl>

                                <div>
                                    <button type="button" class="btn btn-sm btn-danger"
                                        @click="deleteBlock(enrollmentBlock.id)" :disabled="loading">
                                        <i class="fa fa-trash" aria-hidden="true"></i> Remove Enrollment Block
                                    </button>
                                </div>
                            </div>
                            <div v-else class="col-container" style="font-size: 14px; padding: 0 1rem 1rem 1rem;">
                                <div
                                    style="width: 100%; margin-bottom: 1rem; display: flex; justify-content: space-between; background-color: #f0f0f0; border: 1px solid #e3e3e3; border-radius: 5px;">
                                    <div style="padding: 1rem;">
                                        <p>
                                            Current Lease:
                                            <span>
                                                <b>
                                                    <span class="not-available-text" v-if="!this.lease">Not
                                                        Available</span>
                                                    <span class="ineligible-text"
                                                        v-else-if="this.accountable.optOutUnknown">Unknown</span>
                                                    <span class="eligible-text"
                                                        v-else-if="this.accountable.currentLeaseOptOutEligible">Eligible</span>
                                                    <span class="ineligible-text" v-else>Not Eligible</span>
                                                </b>
                                            </span>
                                            <br />
                                            <span
                                                v-if="!this.accountable || !this.lease || (!this.lease.start_at && !this.lease.end_at)">
                                                <i>Unknown lease dates</i>
                                            </span>
                                            <span v-else>
                                                ({{ this.lease.start_at ? new
                                Date(this.lease.start_at).toLocaleDateString() : 'unknown' }}
                                                {{ " - " }}
                                                {{ this.lease.end_at ? new Date(this.lease.end_at).toLocaleDateString()
                                : 'unknown' }})
                                            </span>
                                        </p>
                                        <p>
                                            Upcoming Lease:
                                            <span
                                                :class="this.accountable.upcomingLeaseOptOutEligible ? 'eligible-text' : 'ineligible-text'">
                                                <b>
                                                    <span class="not-available-text" v-if="!this.lease">Not
                                                        Available</span>
                                                    <span class="ineligible-text"
                                                        v-else-if="this.accountable.optOutUnknown">Unknown</span>
                                                    <span class="eligible-text"
                                                        v-else-if="this.accountable.upcomingLeaseOptOutEligible">Eligible</span>
                                                    <span class="ineligible-text" v-else>Not Eligible</span>
                                                </b>
                                            </span>
                                        </p>
                                    </div>
                                    <div
                                        style="background-color: #d0e6f4; margin: .5rem; padding: 1rem 3%; font-weight: 700; color: #03297b; border-radius: 5px;">
                                        <span style="color: #a5b7c3;">ENROLLMENT OFFERS:</span>
                                        <br />
                                        <span>
                                            Price Match
                                            <br />
                                        </span>
                                        <span>
                                            Cancellation Reimbursement
                                            <br />
                                        </span>
                                        <span>
                                            30 Days Free
                                            <br />
                                        </span>
                                    </div>
                                </div>
                                <div v-if="!this.lease"
                                    style="margin: 0 1rem 1rem 1rem; background-color: #f7e5e5; border: 2px solid #fd3e3d; padding: 2rem 1rem 1rem 1rem; border-radius: 5px; text-align: center;">
                                    <p>
                                        This user is not tied to any lease. Try to associate the user to a unit or
                                        resident that has a valid lease.
                                    </p>
                                    <p>
                                        <b>You can still opt this user out, however, there is a chance they will be auto
                                            enrolled again unless we can verify the lease.</b>
                                    </p>
                                </div>
                                <div v-if="this.optOut.override || this.accountable.upcomingLeaseOptOutEligible || this.accountable.currentLeaseOptOutEligible"
                                    class="col-container" style="justify-content: center; width: 100%;">
                                    <div class="form-element-container"
                                        :class="{ 'has-error': errors.has('Block[reason]') }"
                                        style="margin-top: 0.5rem;">
                                        <label for="opt-out-reason">
                                            Why is the <span
                                                v-if="this.accountableType === 'App\\Lease'">resident</span><span
                                                v-else>user</span> opting out?
                                        </label>

                                        <div class="select-wrapper input-error">
                                            <select name="Block[reason]" id="opt-out-reason" v-model="optOut.reason"
                                                v-validate="'required'" required aria-required="true"
                                                class="input-form select-input" @change="onReasonChange($event)"
                                                style="border-radius: 5px; padding-right: 0px;">
                                                <option value="2">Paying less for similar services</option>
                                                <option value="3">Moving out soon</option>
                                                <option value="4">Doesn't want to switch providers</option>
                                                <option value="5">Already has services from the same provider</option>
                                                <option value="1">Other</option>
                                            </select>
                                        </div>

                                        <span v-show="errors.has('Block[reason]')" class="help-block">
                                            {{ errors.first('Block[reason]') }}
                                        </span>
                                    </div>

                                    <div class="form-element-container"
                                        :class="{ 'has-error': errors.has('Block[other]') }"
                                        style="margin-bottom: 0.5rem;" v-if="this.optOut.reason === '1'">
                                        <label for="opt-out-other">
                                            Other
                                        </label>

                                        <input v-validate="'required'" v-model.string="optOut.other"
                                            class="input-form input-error" aria-required="true" id="opt-out-other"
                                            required name="Block[other]" />

                                        <span v-show="errors.has('Block[other]')" class="help-block">
                                            {{ errors.first('Block[other]') }}
                                        </span>
                                    </div>

                                    <div
                                        style="width: 100%; border-radius: 5px; background-color: #f0f0f0; border: 1.5px solid #e4e4e4; margin: 1rem 0; padding: 1.5rem; display: flex; flex-direction: column; justify-content: center;">
                                        <span
                                            v-if="!this.optOut.override && !this.accountable.optOutUnknown && !this.accountable.upcomingLeaseOptOutEligible"
                                            style="text-align: center; width: 100%;">
                                            Inform the <span
                                                v-if="this.accountableType === 'App\\Lease'">resident</span><span
                                                v-else>user</span> they will be auto enrolled upon lease renewal after
                                            {{ this.lease.end_at }}
                                        </span>
                                        <div v-else class="col-container" style="text-align: center;">
                                            <h6><b>Block Auto Enrollment?</b></h6>
                                            <p style="padding: 1rem">This <span
                                                    v-if="this.accountableType === 'App\\Lease'">resident</span><span
                                                    v-else>user</span> has the option to opt out of their future lease
                                                agreement as well.</p>
                                            <label class="switch">
                                                <input type="checkbox" v-model="optOutResidentCheckboxVal" />
                                                <span class="slider round" />
                                            </label>

                                            <div v-if="this.optOutResidentCheckboxVal" style="width: 100%;
                                                display: flex;
                                                flex-direction: column;
                                                align-items: center;"
                                                :class="{ 'has-error': errors.has('Block[expires_at]') }">
                                                <br />
                                                <label for="enrollment-block-expires-at">Block Auto Enroll Until</label>
                                                <input style="max-width: 20rem;" id="enrollment-block-expires-at"
                                                    autocomplete="off" class="form-control input-form input-error"
                                                    name="Block[expires_at]" type="date" required aria-required="true"
                                                    v-validate="'required'" :min="today"
                                                    v-model="enrollmentBlock.expires_at" />

                                                <span v-show="errors.has('Block[expires_at]')" class="help-block">
                                                    {{ errors.first('Block[expires_at]') }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <button :disabled="loading" @click="submitOptOut"
                                        class="account-button primary-button margin-md-top margin-md-bottom">
                                        Submit Opt Out
                                    </button>
                                </div>
                                <div v-else-if="this.accountable.optOutUnknown">
                                    We are unable to verify whether or not the <span
                                        v-if="this.accountableType === 'App\\Lease'">resident</span><span
                                        v-else>user</span> is eligible to opt out.
                                </div>
                                <div
                                    v-else-if="!this.accountable.currentLeaseOptOutEligible && !this.accountable.upcomingLeaseOptOutEligible">
                                    <p style="width: 100%; padding: 0.5rem 2rem; text-align: center;">
                                        This <span v-if="this.accountableType === 'App\\Lease'">resident</span><span
                                            v-else>user</span> is not able to opt out due to their current lease
                                        information.
                                    </p>
                                </div>
                                <button
                                    v-if="!this.optOut.override && (!this.accountable.currentLeaseOptOutEligible || !this.accountable.upcomingLeaseOptOutEligible)"
                                    class="account-button secondary-button" @click="overrideOptOut">
                                    {{ this.accountable.optOutUnknown || !this.accountable.currentLeaseOptOutEligible ?
                                'Override' : 'Override Future Lease' }}
                                </button>
                            </div>
                        </fieldset>
                    </tab>

                    <tab title="History">
                        <audits v-if="modelId" :auditable-id="modelId" auditable-type="App\Account">
                        </audits>

                        <fieldset>
                            <legend>Prior Enrollments</legend>

                            <ul class="list-group"
                                v-if="Array.isArray(pastAccountMembers) && pastAccountMembers.length > 0">
                                <li href="javascript://void(0)" class="list-group-item"
                                    v-for="accountMember in pastAccountMembers" :key="accountMember.id">
                                    {{ accountMember.created_at | date }} Enrollment

                                    <span v-if="accountMember.archivedLabel"
                                        v-html="accountMember.archivedLabel"></span>
                                </li>
                            </ul>

                            <p v-else>No prior enrollments found</p>
                        </fieldset>
                    </tab>
                </tabs>
            </div>
        </modal>
    </div>
</template>

<script>
import AccountAgreements from "./AccountAgreements";
import AccountMembers from "./AccountMembers";
import Audits from "./Audits";
import ProjectPhoneAgreement from "./ProjectPhoneAgreement";

import model from "./mixins/model";

export default {
    mixins: [model],

    components: { AccountAgreements, AccountMembers, Audits, ProjectPhoneAgreement },

    props: {
        canModify: {
            type: Boolean,
            required: true
        },
        accountableId: {
            type: String,
            required: true
        },
        accountableType: {
            type: String,
            required: true
        },
        autoEnrollBlockId: {
            type: String,
        },
        enrollmentBlockId: {
            type: String,
        },
        projectId: {
            type: String,
            required: true
        },
        residentId: {
            type: String,
        },
        partialEnrollment: {
            type: Boolean
        }
    },

    data() {
        return {
            smsCheckboxVal: false,
            originalChargeAmount: null,
            smsNumber: String,
            optOutResidentCheckboxVal: false,
            resident_expires_at: Date,
            residentOptOutDate: Date,
            optOut: {
                override: false,
                reason: null,
                other: '',
            },
        }
    },

    computed: {
        //Override
        resourceKey() {
            return 'Account';
        },

        saveValidationKey() {
            return 'account'
        },

        smsCheckbox() {
            if (model.enrollment_mechanism == 'SMS') {
                return true;
            }
            return false;
        },

        url() {
            if (this.model.id) {
                if (this.model.deleted_at) {
                    return '/api/accounts/' + this.model.id;
                }

                return '/api/accounts/' + this.model.id + '?_load[]=creatingUser&_load[]=accountLease';
            }
            else {
                return '/api/accounts';
            }
        },

        today() {
            return moment().utc().format('YYYY-MM-DD');
        },

        autoEnrollEnabled() {
            let expirationDate = this.autoEnrollBlock && this.autoEnrollBlock.expires_at ? moment.utc(this.autoEnrollBlock.expires_at) : null;

            if (expirationDate) {
                return expirationDate.isBefore(moment().utc());
            }

            return true;
        },

        tomorrow() {
            return moment().utc().add(1, 'days').format('YYYY-MM-DD');
        },

        lease() {
            if (this.accountableType === 'App\\Lease') {
                return this.accountable;
            }
            else if (this.accountableType === 'App\\User') {
                return this.accountable.lease;
            }

            return null;
        }
    },

    methods: {
        beforeLoad() {
            let promises = [
                this.loadAccountHistory(),
                this.loadProject(),
                this.loadAccountable()
            ];

            if (this.autoEnrollBlockId) {
                this.autoEnrollBlock.id = this.autoEnrollBlockId;
            }

            if (this.enrollmentBlockId) {
                this.enrollmentBlock.id = this.enrollmentBlockId;
            }

            if (this.autoEnrollBlock.id) {
                promises.push(this.loadAutoEnrollBlock());
            }

            if (this.enrollmentBlock.id) {
                promises.push(this.loadEnrollmentBlock());
            }

            if (this.residentId) {
                promises.push(this.loadResidentEnrollBlock());
            }

            return Promise.all(promises);
        },

        afterLoad(loadResults) {
            if (!this.model.created_at) {
                this.model.charge = this.project.price.amount;
                if (this.leaseIsRenewal) {
                    this.model.charge = this.project.renewalPrice.amount;
                }
                this.model.project_id = this.projectId;
            }

            if (this.model.chargeBlock) {
                this.chargeBlock = this.model.chargeBlock;
            }
            if (this.model.enrollment_mechanism == 'SMS') {
                this.smsCheckboxVal = true;
            }
            else {
                this.smsCheckboxVal = false;
            }
            this.smsNumber = this.model.sms_number;
            return Promise.resolve();
        },

        beforeSave() {
            if (!this.model.created_at) {
                this.model.accountable_id = this.accountableId;
                this.model.accountable_type = this.accountableType;
            }
            if (this.smsCheckboxVal == true) {
                this.model.enrollment_mechanism = 'SMS';
                this.model.sms_number = this.smsNumber
            }
            if (this.originalChargeAmount !== this.model.charge && this.originalChargeAmount !== null && (!this.chargeBlock.expires_at || moment(this.chargeBlock.expires_at).endOf('day') <= moment().startOf('day'))) {
                this.$notify({
                    type: 'danger',
                    placement: 'top-left',
                    title: 'Cannot update Account Charge without a valid Price Lock End Date',
                });
                this.loading = false;
                throw 'Cannot update Account Charge without a valid Price Lock End Date';
            }
        },

        afterSave() {
            if (!this.chargeBlock.created_at && this.chargeBlock.expires_at) {
                return this.saveChargeBlock();
            } else {
                this.$notify({
                    type: 'success',
                    placement: 'top-left',
                    title: 'Saved Successfully',
                });
                window.location.reload();
            }
        },

        getModelData() {
            return {
                // Lease
                autoEnrollBlock: {
                    'blockable_id': this.accountableId,
                    'blockable_type': this.accountableType,
                    'attribute': 'autoEnroll'
                },

                chargeBlock: {
                    'attribute': 'charge_cents',
                    'blockable_type': 'App\\Account',
                },

                accountable: {},
                leaseIsRenewal: false,

                // User
                enrollmentBlock: {
                    'blockable_id': this.accountableId,
                    'blockable_type': this.accountableType,
                    'attribute': 'accountMember'
                },

                project: {},

                closeOnSave: false,

                pastAccountMembers: [],
            };
        },

        setModel(response) {
            let account = response.data[this.resourceKey];

            // Remove charge cents so it doesn't overtake the Account.charge
            delete account.charge_cents;

            // Set the charge amount to be the charge on the account when it is loaded
            this.originalChargeAmount = account.charge;

            return this.$set(this, 'model', account);
        },

        loadAutoEnrollBlock() {
            var url = '/api/blocks/' + this.autoEnrollBlock.id;

            return axios.get(url)
                .then((response) => {
                    this.$set(this, 'autoEnrollBlock', response.data.Block);
                });
        },

        loadResidentEnrollBlock() {
            var url = '/api/residents/' + this.residentId + '/getOptOutBlockDate';

            return axios.get(url)
                .then((response) => {
                    this.$set(this, 'residentOptOutDate', response.data.OptOutDate);
                });
        },

        loadEnrollmentBlock() {
            var url = '/api/blocks/' + this.enrollmentBlock.id;

            return axios.get(url)
                .then((response) => {
                    this.$set(this, 'enrollmentBlock', response.data.Block);
                });
        },

        loadAccountHistory() {
            var url = '/api/accountMembers?' +
                'accountable_type=' + this.accountableType +
                '&accountable_id=' + this.accountableId +
                '&onlyArchived=true';

            return axios.get(url)
                .then((response) => {
                    this.$set(this, 'pastAccountMembers', response.data.AccountMembers);
                });
        },

        loadAccountable() {
            if (this.accountableType === 'App\\Lease') {
                return this.loadLease();
            }
            else if (this.accountableType === 'App\\User') {
                return this.loadUser();
            }
        },

        loadLease() {
            var url = '/api/leases/' + this.accountableId + '?_load[]=OptOutEligibility';

            return axios.get(url)
                .then((response) => {
                    this.$set(this, 'accountable', response.data.Lease);
                    this.$set(this, 'leaseIsRenewal', response.data.isRenewal);
                });
        },

        loadProject() {
            var url = '/api/projects/' + this.projectId;

            return axios.get(url)
                .then((response) => {
                    this.$set(this, 'project', response.data.Project);
                });
        },

        loadUser() {
            var url = '/api/users/' + this.accountableId + '?_load[]=Address&_load[]=Lease&_load[]=Project&_load[]=OptOutEligibility';

            return axios.get(url)
                .then((response) => {
                    this.$set(this, 'accountable', response.data.User);
                });
        },

        deleteBlock(block_id) {
            this.loading = true;

            return axios.delete('/api/blocks/' + block_id)
                .then(() => {
                    if (block_id === this.autoEnrollBlock.id) {
                        this.$notify({
                            type: 'success',
                            placement: 'top-left',
                            title: 'Auto Enroll Enabled',
                        });
                    }
                    else if (block_id === this.enrollmentBlock.id) {
                        this.$notify({
                            type: 'success',
                            placement: 'top-left',
                            title: 'Opt Out Disabled',
                        });

                        this.closeModal();
                        window.location.reload();
                    }
                    else if (block_id === this.chargeBlock.id) {
                        this.$notify({
                            type: 'success',
                            placement: 'top-left',
                            title: 'Price Lock Removed',
                        });
                    }

                    this.resetData();

                    return this.init();
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch(this.$root.handleErrors);
        },

        saveChargeBlock() {
            let block = this.chargeBlock;
            block.blockable_id = this.model.id;

            return axios.post('/api/blocks', {
                Block: block
            })
                .then((result) => {
                    this.$notify({
                        type: 'success',
                        placement: 'top-left',
                        title: 'Price Lock Created',
                    });
                    window.location.reload();
                })
                .catch(this.$root.handleErrors);
        },

        saveAutoEnrollBlock() {
            this.loading = true;

            return axios.post('/api/blocks', {
                Block: this.autoEnrollBlock
            })
                .then((result) => {
                    this.resetData();

                    this.$notify({
                        type: 'success',
                        placement: 'top-left',
                        title: 'Auto Enroll Disabled',
                    });

                    this.autoEnrollBlock = result.data.Block;

                    this.closeModal();

                    return this.init();
                })
                .catch(this.$root.handleErrors)
                .finally(() => {
                    this.loading = false;
                });
        },

        saveEnrollmentBlock() {
            return axios.post('/api/blocks', {
                Block: this.enrollmentBlock
            })
                .then((res) => {
                    this.$notify({
                        type: 'success',
                        placement: 'top-left',
                        title: 'Successfully opted out',
                    });
                    this.closeModal();
                    window.location.reload();
                })
                .catch((error) => {
                    this.$notify({
                        type: 'danger',
                        placement: 'top-left',
                        title: 'Failed to opt out',
                    });
                });
        },

        overrideOptOut() {
            this.optOut.override = true;
        },

        onReasonChange(event) {
            if (event.target.value !== '1') {
                this.optOut.other = '';
            }
        },

        submitOptOut() {
            this.loading = true;
            this.$validator.validate()
                .then((valid) => {
                    if (valid) {
                        return this.saveEnrollmentBlock();
                    }
                })
                .catch(() => {
                    this.$notify({
                        type: 'danger',
                        placement: 'top-left',
                        title: 'Failed to opt out resident',
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        resetOptOutData() {
            this.optOut = {
                reason: null,
                other: '',
                override: false
            };
            this.optOutResidentCheckboxVal = false;
        },

        openModal() {
            this.resetOptOutData();
            this.$modal.show(this.modalId);
        },
    }
}
</script>
